<div class="w-100 h-100">
	@switch (mainViewer) {
		@case (viewer.LinkViewer) {
			@defer (on immediate) {
				<app-linkviewer
					[catalogKey]="catalogKey"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.ImageViewer) {
			@defer (on immediate) {
				<app-imageviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.PdfViewer) {
			@defer (on immediate) {
				<app-pdfviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.AutodeskViewer) {
			@defer (on immediate) {
				<app-autodeskviewer
					[catalogViewService]="catalogViewService"
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.BimObjectViewer) {
			@defer (on immediate) {
				<app-bimobjectviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[catalogLanguage]="catalogLanguage"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.CadClickViewer) {
			@defer (on immediate) {
				<app-cadclickviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.CadenasViewer) {
			@defer (on immediate) {
				<app-cadenasviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.FileViewer) {
			@defer (on immediate) {
				<app-fileviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.VimeoVideoViewer) {
			@defer (on immediate) {
				<app-vimeovideoviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.YoutubeVideoViewer) {
			@defer (on immediate) {
				<app-ytvideoviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.FileVideoViewer) {
			@defer (on immediate) {
				<app-filevideoviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.TextViewer) {
			@defer (on immediate) {
				<app-textviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.ProtocolViewer) {
			@defer (on immediate) {
				<app-protocolviewer
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.FolderContentViewer) {
			@defer (on immediate) {
				<app-folder-viewer
					[catalogViewService]="catalogViewService"
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.CatalogInfoViewer) {
			<!-- Ohne @defer: dieser Fall rendert /catalog/<key>, einen der beiden gecrawlten
			     Pfade, und die Komponente zieht nur LibCatalogInfoViewerComponent nach. Alle
			     anderen @case-Zweige bleiben nachgeladen - dort hängen PDF, Autodesk und
			     CADENAS dran, die nichts im initialen Bundle zu suchen haben. -->
			<app-cataloginfoviewer
				[catalogKey]="catalogKey"
				[catalogViewService]="catalogViewService"
				(contactFormOpen)="contactFormOpen?.emit($event)" />
		}
		@case (viewer.CatalogContactViewer) {
			@defer (on immediate) {
				<app-catalogcontactviewer
					[catalogKey]="catalogKey"
					[catalogViewService]="catalogViewService"
					(contactFormOpen)="contactFormOpen?.emit($event)" />
			}
		}
		@case (viewer.CatalogRelationsViewer) {
			@defer (on immediate) {
				<app-catalogrelationsviewer
					[currentRoutingParams]="routingParams"
					[queryParams]="queryParams"
					[relatedCatalogs]="catalogContentViewersViewModel.relatedCatalogs"
					[languageCatalogs]="catalogContentViewersViewModel.foreignLanguageCatalogs" />
			}
		}
		@case (viewer.CatalogContactPersonViewer) {
			@defer (on immediate) {
				<app-catalogcontactperson-viewer
					[catalogViewService]="catalogViewService"
					(contactFormOpen)="contactFormOpen?.emit($event)" />
			}
		}
		@case (viewer.AboutUsAboutUsViewer) {
			@defer (on immediate) {
				<app-about-us-category-viewer [aboutUsCategory]="catalogAboutUsCategory.AboutUs" [currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.AboutUsSustainabilityViewer) {
			@defer (on immediate) {
				<app-about-us-category-viewer
					[aboutUsCategory]="catalogAboutUsCategory.Sustainability"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.AboutUsReferencesViewer) {
			@defer (on immediate) {
				<app-about-us-category-viewer
					[aboutUsCategory]="catalogAboutUsCategory.References"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.AboutUsServiceViewer) {
			@defer (on immediate) {
				<app-about-us-category-viewer
					[aboutUsCategory]="catalogAboutUsCategory.ServiceAdviceTools"
					[currentRoutingParams]="routingParams"
					(contactFormOpen)="contactFormOpen?.emit($event)" />
			}
		}
		@case (viewer.WatchlistRoot) {
			@defer (on immediate) {
				<app-watchlist-rootviewer />
			}
		}
		@case (viewer.WatchlistUserdefinedRoot) {
			@defer (on immediate) {
				<app-watchlist-userdefined-rootviewer />
			}
		}
		@case (viewer.WatchlistUserdefinedFolder) {
			@defer (on immediate) {
				<app-folder-viewer
					[catalogViewService]="catalogViewService"
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
		@case (viewer.SustainabilityViewer) {
			@defer (on immediate) {
				<app-sustainability-viewer
					[catalogViewService]="catalogViewService"
					[catalogKey]="catalogKey"
					[attachments]="attachments"
					[attachment]="attachment"
					[catalogDetailsType]="catalogDetailsType"
					[catalogItemGuid]="catalogItemGuid"
					[url]="url"
					[featureToggles]="featureToggles"
					[currentRoutingParams]="routingParams" />
			}
		}
	}
</div>
